import { CmsRegistrationRoot } from '../cms/cms-registration-root.interface';
import { CmsProtectionUpsellPanel } from '../protection-upsell/cms-protection-upsell-panel.interface';
import { CmsApplianceDetailsForm } from './cms-appliance-details-form.interface';

export interface CmsApplianceDetailsPage
  extends CmsRegistrationRoot,
    CmsApplianceDetailsForm,
    CmsProtectionUpsellPanel {
  pageTitle: string;
  pageSubtitle?: string;
}
